import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaiairporttopunecab() {



  const cardData = {
    keyword: " Navi Mumbai Airport to Pune Cab   ",


"headingDescription": "Royal Route Cab offers reliable Navi Mumbai Airport to Pune cab service, providing safe, comfortable, and affordable intercity travel for business travelers, families, tourists, and daily commuters. The distance between Navi Mumbai Airport and Pune is approximately 150–170 km, making it a smooth and convenient highway journey via express routes. Our professional drivers ensure punctual airport pickup, luggage assistance, and a stress-free travel experience with well-maintained vehicles. We offer flexible options including one-way drops, round trips, corporate travel, and customized travel plans. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all group sizes. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is a trusted choice for Navi Mumbai Airport to Pune cab service.",

"topPlaces": [
  {
    "title": "Pune City Center",
    "description": "Pune City Center is the main commercial and cultural hub of Pune, known for its IT parks, shopping malls, restaurants, and educational institutions. It is a common drop point for airport travelers arriving from Navi Mumbai, offering easy access to business and residential areas."
  },
  {
    "title": "Shivajinagar",
    "description": "Shivajinagar is a major transit and business area in Pune known for government offices, markets, and transport connectivity. It is a key location for travelers coming from Navi Mumbai Airport due to its central positioning."
  },
  {
    "title": "Hinjewadi IT Park",
    "description": "Hinjewadi IT Park is Pune’s largest IT hub, home to major multinational companies and tech offices. Many corporate travelers prefer direct airport cabs from Navi Mumbai to Hinjewadi for quick and convenient business travel."
  },
  {
    "title": "Koregaon Park",
    "description": "Koregaon Park is one of Pune’s most premium residential and lifestyle areas known for cafes, nightlife, and greenery. It is a popular drop location for tourists and business travelers alike."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic monument associated with Mahatma Gandhi and India’s freedom movement. It is a major heritage attraction in Pune and often visited by travelers during leisure trips."
  },
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fortification in Pune that served as the seat of the Peshwas. It is known for its architectural grandeur and historical significance, attracting tourists from across India."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a popular hill fort near Pune offering trekking opportunities and panoramic views of the Sahyadri mountains. It is a favorite weekend destination for travelers."
  },
  {
    "title": "Lonavala (En Route Option)",
    "description": "Lonavala is a scenic hill station located between Pune and Mumbai, often included as a stopover during cab journeys. It is known for its waterfalls, viewpoints, and pleasant climate."
  },
  {
    "title": "Lavasa City",
    "description": "Lavasa is a planned hill city near Pune known for its lakeside views and European-style architecture. It is a popular leisure destination for travelers arriving from the airport."
  },
  {
    "title": "Pimpri-Chinchwad",
    "description": "Pimpri-Chinchwad is a major industrial and residential area near Pune, often chosen as a drop location for business and corporate travelers coming from Navi Mumbai Airport."
  }
],






services: [
  {
    name: "Mumbai Airport to Pune Cab",
    description: "Mumbai airport to Pune cab service offers a comfortable and direct transfer from the airport to Pune. Ideal for business travelers, families, and tourists, this service ensures smooth highway travel via expressway. Professional drivers and clean vehicles enhance safety. It guarantees a hassle-free journey."
  },
  {
    name: "Mumbai to Pune Cab Service",
    description: "Mumbai to Pune cab service provides reliable intercity travel with flexible pickup options including airport transfers. This service is ideal for daily commuters and long-distance travelers. Comfortable seating ensures a smooth ride. It guarantees a convenient travel experience."
  },
  {
    name: "Mumbai Airport to Pune Taxi Fare",
    description: "Mumbai airport to Pune taxi fare is designed to be transparent and competitive. Pricing varies based on vehicle type and trip type. Customers receive clear cost details before booking. It helps in planning travel budget efficiently."
  },
  {
    name: "Mumbai Pune Cab One Way",
    description: "Mumbai Pune cab one way offers cost-effective travel without return charges. This service is ideal for single-side trips from airport or city. Flexible pickup timing enhances convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Pune Cab from Airport",
    description: "Mumbai to Pune cab from airport provides seamless pickup directly from airport terminals. Ideal for travelers arriving in Mumbai and heading to Pune. Professional drivers ensure timely service. It guarantees a stress-free transfer."
  },
  {
    name: "Mumbai Airport to Pune Cab Fare",
    description: "Mumbai airport to Pune cab fare depends on vehicle type, distance, and travel time. Transparent pricing ensures no hidden charges. Customers can choose budget or premium options. It ensures value for money."
  },
  {
    name: "Mumbai International Airport to Pune Cab",
    description: "Mumbai international airport to Pune cab offers direct transfers from Terminal 2 and other terminals. Ideal for international travelers needing reliable transport. Comfortable vehicles enhance travel experience. It ensures smooth connectivity."
  },
  {
    name: "Mumbai to Pune Taxi from Airport",
    description: "Mumbai to Pune taxi from airport provides convenient and private travel for long-distance journeys. Door-to-door service enhances comfort. Suitable for families and business travelers. It ensures a reliable ride."
  },
  {
    name: "Navi Mumbai Airport to Pune Cab",
    description: "Navi Mumbai airport to Pune cab service offers quick and efficient travel between the new airport and Pune. Ideal for business and personal travel. Professional drivers ensure safe journeys. It guarantees a smooth ride."
  },
  {
    name: "Navi Mumbai Airport to Pune Taxi",
    description: "Navi Mumbai airport to Pune taxi provides convenient and private transportation with flexible scheduling. This service is ideal for airport pickups and drops. Comfortable vehicles ensure a pleasant journey. It guarantees reliability."
  },
  {
    name: "Navi Mumbai Airport to Pune Cab Service",
    description: "Navi Mumbai airport to Pune cab service ensures dependable intercity travel with professional drivers. Suitable for families, corporate clients, and group travelers. Clean vehicles enhance comfort. It ensures a safe journey."
  },
  {
    name: "Navi Mumbai Airport to Pune Taxi Service",
    description: "Navi Mumbai airport to Pune taxi service offers reliable transportation with flexible booking options. Ideal for timely airport transfers. Experienced drivers ensure smooth travel. It guarantees a stress-free experience."
  },
  {
    name: "Cab from Navi Mumbai Airport to Pune",
    description: "Cab from Navi Mumbai airport to Pune offers direct and convenient travel from airport terminals to Pune city. Ideal for quick transfers after flights. Professional drivers ensure punctuality. It ensures a relaxed journey."
  },
  {
    name: "Book Cab from Navi Mumbai Airport to Pune",
    description: "Book cab from Navi Mumbai airport to Pune with easy online booking and instant confirmation. Customers can choose vehicle type and timing. Transparent pricing ensures trust. It simplifies travel planning."
  },
  {
    name: "Online Cab Booking Navi Mumbai Airport to Pune",
    description: "Online cab booking Navi Mumbai airport to Pune provides a fast and convenient way to reserve your ride. Secure payment and instant confirmation enhance convenience. Multiple vehicle options are available. It ensures hassle-free booking."
  },
  {
    name: "Best Cab Navi Mumbai Airport to Pune",
    description: "Best cab Navi Mumbai airport to Pune ensures top-quality vehicles, professional drivers, and excellent service. This service focuses on comfort, safety, and punctuality. It guarantees a premium travel experience."
  },
  {
    name: "Cheapest Cab Navi Mumbai Airport to Pune",
    description: "Cheapest cab Navi Mumbai airport to Pune offers budget-friendly travel options without compromising comfort. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical travel."
  },
  {
    name: "Reliable Taxi Navi Mumbai Airport to Pune",
    description: "Reliable taxi Navi Mumbai airport to Pune provides dependable transportation with verified drivers and well-maintained vehicles. This service ensures timely pickups and drops. It guarantees a safe journey."
  },
  {
    name: "Airport Pickup Cab Navi Mumbai to Pune",
    description: "Airport pickup cab Navi Mumbai to Pune offers seamless pickup from arrival terminals with professional drivers. Flight tracking ensures timely service. Comfortable vehicles enhance travel experience. It ensures a smooth transfer."
  }
],

tableData: [
  ["Mumbai Airport to Pune Cab", "Mumbai to Pune Cab Service"],
  ["Mumbai Airport to Pune Taxi Fare", "Mumbai Pune Cab One Way"],
  ["Mumbai to Pune Cab from Airport", "Mumbai Airport to Pune Cab Fare"],
  ["Mumbai International Airport to Pune Cab", "Mumbai to Pune Taxi from Airport"],
  ["Navi Mumbai Airport to Pune Cab", "Navi Mumbai Airport to Pune Taxi"],
  ["Navi Mumbai Airport to Pune Cab Service", "Navi Mumbai Airport to Pune Taxi Service"],
  ["Cab from Navi Mumbai Airport to Pune", "Book Cab from Navi Mumbai Airport to Pune"],
  ["Online Cab Booking Navi Mumbai Airport to Pune", "Best Cab Navi Mumbai Airport to Pune"],
  ["Cheapest Cab Navi Mumbai Airport to Pune", "Reliable Taxi Navi Mumbai Airport to Pune"],
  ["Airport Pickup Cab Navi Mumbai to Pune", ""]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Navi Mumbai Airport to Pune Travel",
    WhyChoosedescription: "Royal Route Cabs offers smooth and comfortable cab service from Navi Mumbai Airport to Pune, ideal for business trips, family travel, and airport transfers."
  },
  {
    WhyChooseheading: "On-Time Airport Pickup with Flight Tracking",
    WhyChoosedescription: "We track flight timings to ensure timely pickup even in case of delays, providing a stress-free airport transfer experience."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are well-trained in Mumbai-Pune Expressway routes, ensuring safe driving and quick travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai Airport to Pune cab service operates round the clock for late-night arrivals and early departures."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and sanitized regularly for a comfortable ride."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Airport Transfer Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for reliable airport transfers with punctual service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Navi Mumbai Airport to Pune cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Navi Mumbai Airport to Pune." },
  { question: "What is the distance between Navi Mumbai Airport and Pune?", answer: "The distance is approximately 150 to 170 km and takes around 3 to 4 hours via expressway." },
  { question: "What is the cab fare for this route?", answer: "Cab fares typically start from ₹1800 to ₹3000 depending on vehicle type and package." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip cab services." },
  { question: "Do you track flight delays?", answer: "Yes, we track flights to ensure timely pickup." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep drop in Pune?", answer: "Yes, we provide drop to home, hotel, or office anywhere in Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Kulkarni",
    feedback: "The Navi Mumbai Airport to Pune cab service with Royal Route Cabs was very smooth and punctual. The highway ride was comfortable and well-managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Patil",
    feedback: "Excellent experience traveling from Navi Mumbai Airport to Pune. The cab was clean, the driver was professional, and the journey felt safe and relaxing.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport to Pune Cab",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-airport-to-pune-cab.jpg", // replace if needed
  "description": "Book Navi Mumbai Airport to Pune cab service with Royal Route Cabs for safe, reliable, and comfortable intercity travel. Available 24x7 with sedan, SUV, Innova, Ertiga, and premium vehicles for airport pickup and drop service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999", // approx starting airport-to-pune fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-airport-to-pune-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Navi Mumbai Airport to Pune Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport to Pune cab with Royal Route Cabs. Safe and affordable airport transfer service with 24x7 availability, professional drivers, and comfortable vehicles."
  />

  <meta
    name="keywords"
    content="mumbai airport to pune cab, mumbai to pune cab service, mumbai airport to pune taxi fare, mumbai pune cab one way, mumbai to pune cab from airport, mumbai airport to pune cab fare, mumbai international airport to pune cab, mumbai to pune taxi from airport, navi mumbai airport to pune cab, navi mumbai airport to pune taxi, navi mumbai airport to pune cab service, navi mumbai airport to pune taxi service, cab from navi mumbai airport to pune, book cab from navi mumbai airport to pune, online cab booking navi mumbai airport to pune, best cab navi mumbai airport to pune, cheapest cab navi mumbai airport to pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/74.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairporttopunecab;